<template>
    <div class="container mx-auto w-full pb-24">
		<!-- <div class="text-2xl font-semibold p-4">Создать предложение</div> -->
        <div class="flex flex-col gap-1 px-4">
            <div class="flex flex-col gap-4 w-full">
                <div class="flex flex-col gap-1 w-full">
                    <div class="pl-8 pt-4">Город отправки:</div>
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=59830&format=png" class="h-4 w-8 px-2">
                        <select v-model="form.departure_city" class="h-12 px-2 text-md w-full rounded-l-md dark:bg-stone-500 dark:text-stone-900">
                            <option v-for="city, index in cities" :key="index" :value="city.name">{{ city.name }}</option>
                        </select>
                        <!-- <input v-model="form.departure_address" type="text" placeholder="Адрес посадки" class="h-12 px-4 text-lg w-2/3 rounded-r-md border-l dark:border-stone-700 dark:bg-stone-500 dark:text-stone-900"/> -->
                    </div>
                </div>
                
                <div class="flex flex-col gap-1 w-full">
                    <div class="pl-8 pt-4">Город прибытия:</div>
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=59830&format=png" class="h-4 w-8 px-2">
                        <select v-model="form.destination_city" class="h-12 px-2 text-md w-full rounded-l-md  dark:bg-stone-500 dark:text-stone-900">
                            <option v-for="city, index in cities" :key="index" :value="city.name">{{ city.name }}</option>
                        </select>
                        <!-- <input v-model="form.destination_address" type="text" placeholder="Адрес прибытия" class="h-12 px-4 text-lg w-2/3 rounded-r-md border-l dark:border-stone-700 dark:bg-stone-500 dark:text-stone-900"/> -->
                    </div>
                </div>
                
                <div class="flex flex-col gap-1 w-full">
                    <!-- <div class="text-lg">
                        Цена
                    </div> -->
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=256w&id=VfeBw5ao3Irv&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.price" type="number" placeholder="Цена" class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500 dark:text-stone-900"/>
                    </div>
                </div>
                
                <!-- <div class="flex flex-col gap-1 w-full">
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=9730&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.contact_phone" type="number" 
                            placeholder="Контактный телефон" 
                            class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500 dark:text-stone-900" />
                    </div>
                </div> -->
                
                <div class="flex flex-col gap-1 w-full">
                    <!-- <div class="text-lg">
                        Комментарий
                    </div> -->
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=100&id=2951&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.comment" type="text" placeholder="Комментарий" class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500 dark:text-stone-900"/>
                    </div>
                </div>
                <div v-if="errors.length > 0" class="py-2 px-8">
                    <div v-for="error,index in errors" :key="index" class="text-xl text-rose-500">- {{ error }}</div>
                </div>
                <div class="flex flex-row justify-center pt-4">
                    <input type="submit" @click="offerStore" value="Опубликовать" class="cursor-pointer text-black rounded-lg py-2 px-4 text-lg w-1/2 bg-emerald-500 text-white font-semibold"/>
                </div>
                <div class="flex flex-row items-center opacity-30 dark:opacity-70">
                    <img src="https://img.icons8.com/?size=256&id=10034&format=png" class="h-4 w-8 px-2">
                    <div class="pl-4">Публикация сразу</div>
                </div>
                <div class="flex flex-row items-center opacity-30 dark:opacity-70">
                    <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                    <div class="pl-4">После публикации ваше объявление будет актуально <b>40</b> минут, после чего автоматически деактивируется</div>
                </div>
                <div class="flex flex-row items-center opacity-30 dark:opacity-70">
                    <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                    <div class="pl-4">Вы можете опубликовать еще <b>{{ this.$store.state.user?.balance }}</b> поездок</div>
                </div>
                <div class="flex flex-row items-center opacity-30 dark:opacity-70">
                    <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                    <div class="pl-4">Пополнение баланса и другие вопросы по телефонам поддержки сервиса </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                departure_city: 'Павлодар',
                departure_address: '',
                destination_city: 'Аксу',
                destination_address: '',
                price: null,
                // contact_phone: null,
                comment: '',
            },
			cities: [],
            errors: []
        }
    },
    methods: {
		getCities () {
			this.getServerData('cities').then((res) => {
				res = res.data
				if(res.status != 404) {
					this.cities = res.data
				}
			})
		},
        offerStore () {
            this.errors = []
            // if (this.form.departure_address.length == 0){ 
            //     this.errors.push("Введите адрес посадки")
            //     return
            // } 
            // if (this.form.destination_address.length == 0){ 
            //     this.errors.push("Введите адрес прибытия")
            //     return
            // } 
            if (this.form.price == null){ 
                this.errors.push("Укажите вашу цену")
                return
            } 
            // if (this.form.contact_phone == null){ 
            //     this.errors.push("Укажите контактный телефон")
            //     return
            // } 
            this.postServerData('transporter_offers_store', { data: this.form })
            .finally(()=>{
                this.$router.push('/offers/transporter/my')
            })
        }
    },
    mounted() {
        this.getCities()
        this.form.contact_phone = this.$store.state.user.contact_phone
    },
    
}
</script>
<style scoped>
    
</style>